import { FunctionComponent as F, useEffect, useState } from "react";
import IconPopper from "./IconPopper";
import { useSelector } from "react-redux";
import { IState } from "../../../core/store/store";
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { updateDosingNoteAsync } from "../../../core/store/protocol/protocol.thunks";
import { useAppDispatch } from "../../../core/store/hooks";


interface Props
{
  protocolId: number,
  dosingId: number,
  rowIndex: number
}

const DosingNote: F<Props> = (props: Props) =>
{
  const appDispatch = useAppDispatch();

  const protocol = useSelector((state: IState) => state.protocol.protocols
    .find(p =>  p.protocolId === props.protocolId));
  const dosing = useSelector((state: IState) =>
  {
    const dosings = state.protocol.protocols.find(p =>  p.protocolId === props.protocolId)?.dosings;
    if(dosings)
      return dosings[props.rowIndex];
  });

  const [note, setNote] = useState(dosing?.note);

  useEffect(() =>
  {
    setNote(dosing?.note);
  }, [dosing?.note]);

  const handleChange = async(event: React.ChangeEvent<HTMLTextAreaElement>) =>
  {
    setNote(event.target.value);
    new Promise(r => setTimeout(r, 100))
      .then(() => appDispatch(updateDosingNoteAsync(props.protocolId, props.rowIndex, event.target.value)));
  };


  const tooltip =
    <TextareaAutosize
      disabled={!protocol?.edit}
      value={note}
      onChange={handleChange}/>;


  return(
    <IconPopper
      Content={tooltip}
      Icon={
        <EditNoteIcon
          fontSize='small'
          sx={{
            height: 17,
            color: note ? 'green' : 'lightGray',
            cursor: 'pointer' }}
          style={{ display: "flex", justifyContent: "center" }}/>}/>);
  };

export default DosingNote;
